import { render, staticRenderFns } from "./vip_packages.vue?vue&type=template&id=453a833d&scoped=true&"
import script from "./vip_packages.vue?vue&type=script&lang=js&"
export * from "./vip_packages.vue?vue&type=script&lang=js&"
import style0 from "./vip_packages.vue?vue&type=style&index=0&id=453a833d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a833d",
  null
  
)

export default component.exports